import { LANGUAGE } from "@/common/utils/constants.js";

export const GOP_HOME_PAGE_TRANSLATIONS = {
	[LANGUAGE.en.short]: {
		home: 'Home',
		readyToSell: 'Create a ready-to-sell offer',
		gtmPositioning: 'GTM Positioning',
		globalExpertiseAndOffers: 'Global Expertise & Offers',
		globalClientPresentation: 'Global Client Presentation',
		highlights: 'HIGHLIGHTS',
		learnMore: 'Learn more ',
		ourExpertiseAndOffers: 'Our Expertise & Offers',
		savedContent: 'Saved Content',
		info1: 'Explore our global and local expertise across key industries and core technologies, and discover solutions that drive innovation worldwide.\n' +
			'\t\t\t\t\tCheck out curated highlights showcasing our best work or explore strategic partnerships and achieved global recognitions.',
		info2: 'Discover the power of GOP and learn how to make the most of it -  ',
		info3: 'watch the video now and unlock its full potential!',
		industries: 'Industries',
		products: 'Products',
		techPractices: "Tech Practices",
		partnerships: 'Partnerships',
		recognitions: 'Recognitions',
		offers: "Offers",
		sectors: 'Sector Presentations',
		countries: {
			"Australia": "Australia",
			"Austria": "Austria",
			"Belgium": "Belgium",
			"Bulgaria": "Bulgaria",
			"Canada": "Canada",
			"China": "China",
			"Colombia": "Colombia",
			"Czech Republic": "Czech Republic",
			"Denmark": "Denmark",
			"France": "France",
			"Germany": "Germany",
			"Hungary": "Hungary",
			"India": "India",
			"Italy": "Italy",
			"Japan": "Japan",
			"Mexico": "Mexico",
			"Morocco": "Morocco",
			"Netherlands": "Netherlands",
			"Norway": "Norway",
			"Poland": "Poland",
			"Portugal": "Portugal",
			"Qatar": "Qatar",
			"Romania": "Romania",
			"Singapore": "Singapore",
			"Spain": "Spain",
			"Sweden": "Sweden",
			"Switzerland": "Switzerland",
			"Taiwan": "Taiwan",
			"Thailand": "Thailand",
			"UK & Ireland": "UK & Ireland",
			"United Arab Emirates (UAE)": "United Arab Emirates (UAE)",
			"United States of America (USA)": "United States of America (USA)"
		},
		emptyPartnership: 'No available partnership.',
		emptyRecognitions: 'No available recognitions.',
		getStarted: "Get started",
		watchAShortVideo: 'Watch a short video to learn the basics.',
		search: "Search",
		find: "Find expertise, offers, or recognitions easily by using the global search.",
		highlightsAndQuickAccess: "Highlights & Quick Access",
		exploreKeyHighlights: "Explore key highlights, available expertise & offers or your saved content in one click.",
		globalAndLocalExpertise: "Global & Local Expertise",
		exploreOurWorldwide: "Explore our worldwide tech & digital engineering expertise or our local expertise across different countries.",
		partnerShipsAndRecognitions: "Partnerships & Recognitions",
		discoverOurStrategic: "Discover our strategic partnerships and achievements.",
		suggestContent: "Suggest Content",
		shareIdeas: "Share ideas for new or missing expertise, offers or recognitions.",
		viewAll: "View all"
	},
	[LANGUAGE.de.short]: {
		home: 'Startseite',
		readyToSell: 'Erstelle ein verkaufsfertiges Angebot',
		gtmPositioning: 'GTM-Positionierung',
		globalExpertiseAndOffers: 'Globale Expertise & Angebote',
		globalClientPresentation: 'Globale Kundenpräsentation',
		highlights: 'Highlights',
		learnMore: 'Mehr erfahren ',
		ourExpertiseAndOffers: 'Unsere Expertise & Angebote',
		savedContent: 'Gespeicherte Inhalte',
		info1: 'Entdecken Sie unsere globale und lokale Expertise in Schlüsselbranchen und Kerntechnologien und finden Sie Lösungen, die Innovationen weltweit vorantreiben.\n' +
			'\t\t\t\t\tSehen Sie sich ausgewählte Highlights unserer besten Projekte an oder informieren Sie sich über strategische Partnerschaften und internationale Auszeichnungen.',
		info2: 'Entdecken Sie die Macht der Republikaner und lernen Sie, sie optimal zu nutzen – ',
		info3: 'sehen Sie sich jetzt das Video an und schöpfen Sie ihr volles Potenzial aus!',
		industries: 'Branchen',
		products: 'Produkte',
		techPractices: "Technische Verfahren",
		partnerships: 'Partnerschaften',
		recognitions: 'Auszeichnungen',
		offers: "Angebote",
		sectors: 'Sektorpräsentationen',
		countries: {
			"Australia": "Australien",
			"Austria": "Österreich",
			"Belgium": "Belgien",
			"Bulgaria": "Bulgarien",
			"Canada": "Kanada",
			"China": "China",
			"Colombia": "Kolumbien",
			"Czech Republic": "Tschechien",
			"Denmark": "Dänemark",
			"France": "Frankreich",
			"Germany": "Deutschland",
			"Hungary": "Ungarn",
			"India": "Indien",
			"Italy": "Italien",
			"Japan": "Japan",
			"Mexico": "Mexiko",
			"Morocco": "Marokko",
			"Netherlands": "Niederlande",
			"Norway": "Norwegen",
			"Poland": "Polen",
			"Portugal": "Portugal",
			"Qatar": "Katar",
			"Romania": "Rumänien",
			"Singapore": "Singapur",
			"Spain": "Spanien",
			"Sweden": "Schweden",
			"Switzerland": "Schweiz",
			"Taiwan": "Taiwan",
			"Thailand": "Thailand",
			"UK & Ireland": "UK & Irland",
			"United Arab Emirates (UAE)": "Vereinigte Arabische Emirate (VAE)",
			"United States of America (USA)": "Vereinigte Staaten von Amerika (USA)"
		},
		emptyPartnership: 'Keine Partnerschaften verfügbar.',
		emptyRecognitions: 'Keine Auszeichnungen verfügbar.',
		getStarted: "Loslegen",
		watchAShortVideo: 'Sehen Sie sich ein kurzes Video an, um die Grundlagen zu lernen.',
		search: "Suchen",
		find: "Finden Sie Expertise, Angebote oder Auszeichnungen einfach mit der globalen Suche.",
		highlightsAndQuickAccess: "Highlights & Schnellzugriff",
		exploreKeyHighlights: "Entdecken Sie wichtige Highlights, verfügbare Expertise & Angebote oder Ihre gespeicherten Inhalte mit einem Klick.",
		globalAndLocalExpertise: "Globale & Lokale Expertise",
		exploreOurWorldwide: "Entdecken Sie unsere weltweite Tech- & Digital-Engineering-Expertise oder unsere lokale Expertise in verschiedenen Ländern.",
		partnerShipsAndRecognitions: "Partnerschaften & Auszeichnungen",
		discoverOurStrategic: "Entdecken Sie unsere strategischen Partnerschaften und Erfolge.",
		suggestContent: "Inhalte vorschlagen",
		shareIdeas: "Teilen Sie Ideen für neue oder fehlende Expertise, Angebote oder Auszeichnungen.",
		viewAll: "Alle anzeigen"
	},
	[LANGUAGE.fr.short]: {
		home: 'Page d\'accueil',
		readyToSell: 'Créer une offre prête à la vente',
		gtmPositioning: 'Positionnement GTM',
		globalExpertiseAndOffers: 'Expertise et offres internationales',
		globalClientPresentation: 'Présentation client internationale',
		highlights: 'POINTS FORTS',
		learnMore: 'En savoir plus ',
		ourExpertiseAndOffers: 'Notre expertise et nos offres',
		savedContent: 'Contenu enregistré',
		info1: 'Explorez notre expertise mondiale et locale dans des secteurs clés et des technologies fondamentales, et découvrez des solutions qui stimulent l\'innovation à l\'échelle internationale.\n' +
			'\t\t\t\t\tConsultez une sélection de nos meilleures réalisations ou explorez nos partenariats stratégiques et nos distinctions internationales.',
		info2: 'Découvrez la puissance du Parti républicain et apprenez à en tirer le meilleur parti - ',
		info3: 'Regardez la vidéo dès maintenant et libérez tout son potentiel!',
		industries: 'Secteurs d\'activité',
		products: 'Produits',
		techPractices: "Pratiques technologiques",
		partnerships: 'Partenariats',
		recognitions: 'Reconnaissances',
		offers: "Offres",
		sectors: 'Présentations sectorielles',
		countries: {
			"Australia": "Australie",
			"Austria": "Autriche",
			"Belgium": "Belgique",
			"Bulgaria": "Bulgarie",
			"Canada": "Canada",
			"China": "Chine",
			"Colombia": "Colombie",
			"Czech Republic": "République Tchèque",
			"Denmark": "Danemark",
			"France": "France",
			"Germany": "Allemagne",
			"Hungary": "Hongrie",
			"India": "Inde",
			"Italy": "Italie",
			"Japan": "Japon",
			"Mexico": "Mexique",
			"Morocco": "Maroc",
			"Netherlands": "Pays-Bas",
			"Norway": "Norvège",
			"Poland": "Pologne",
			"Portugal": "Portugal",
			"Qatar": "Qatar",
			"Romania": "Roumanie",
			"Singapore": "Singapour",
			"Spain": "Espagne",
			"Sweden": "Suède",
			"Switzerland": "Suisse",
			"Taiwan": "Taïwan",
			"Thailand": "Thaïlande",
			"UK & Ireland": "Royaume-Uni et Irlande",
			"United Arab Emirates (UAE)": "Émirats Arabes Unis (EAU)",
			"United States of America (USA)": "États-Unis d'Amérique (USA)"
		},
		emptyPartnership: 'Aucun partenariat disponible.',
		emptyRecognitions: 'Aucune reconnaissance disponible.',
		getStarted: "Commencer",
		watchAShortVideo: 'Regardez une courte vidéo pour apprendre les bases.',
		search: "Rechercher",
		find: "Trouvez facilement une expertise, des offres ou des reconnaissances en utilisant la recherche globale.",
		highlightsAndQuickAccess: "Points forts & Accès rapide",
		exploreKeyHighlights: "Découvrez les points forts clés, l'expertise et les offres disponibles ou votre contenu enregistré en un clic.",
		globalAndLocalExpertise: "Expertise mondiale et locale",
		exploreOurWorldwide: "Découvrez notre expertise mondiale en technologie et ingénierie numérique ou notre expertise locale dans différents pays.",
		partnerShipsAndRecognitions: "Partenariats & Reconnaissances",
		discoverOurStrategic: "Découvrez nos partenariats stratégiques et nos réalisations.",
		suggestContent: "Suggérer du contenu",
		shareIdeas: "Partagez des idées pour de nouvelles ou des expertises, offres ou reconnaissances manquantes.",
		viewAll: "Voir tout"
	},
	[LANGUAGE.it.short]: {
		home: 'Pagina iniziale',
		readyToSell: 'Crea un\'offerta pronta per la vendita',
		gtmPositioning: 'Posizionamento GTM',
		globalExpertiseAndOffers: 'Competenze e offerte globali',
		globalClientPresentation: 'Presentazione ai clienti globali',
		highlights: 'IN EVIDENZA',
		learnMore: 'Scopri di più ',
		ourExpertiseAndOffers: 'La nostra esperienza e le nostre offerte',
		savedContent: 'Contenuti salvati',
		info1: 'Esplora la nostra esperienza globale e locale nei settori chiave e nelle tecnologie principali e scopri le soluzioni che guidano l\'innovazione in tutto il mondo.\n' +
			'\t\t\t\t\tConsulta una selezione dei nostri migliori progetti o scopri le partnership strategiche e i riconoscimenti internazionali ottenuti.',
		info2: 'Scopri il potere del Partito Repubblicano e impara come sfruttarlo al meglio - ',
		info3: 'guarda subito il video e libera tutto il suo potenziale!',
		industries: 'Industrie',
		products: 'Prodotti',
		techPractices: "Pratiche tecnologiche",
		partnerships: 'Partnership',
		recognitions: 'Riconoscimenti',
		offers: "Offerte",
		sectors: 'Presentazioni di settore',
		countries: {
			"Australia": "Australia",
			"Austria": "Austria",
			"Belgium": "Belgio",
			"Bulgaria": "Bulgaria",
			"Canada": "Canada",
			"China": "Cina",
			"Colombia": "Colombia",
			"Czech Republic": "Repubblica Ceca",
			"Denmark": "Danimarca",
			"France": "Francia",
			"Germany": "Germania",
			"Hungary": "Ungheria",
			"India": "India",
			"Italy": "Italia",
			"Japan": "Giappone",
			"Mexico": "Messico",
			"Morocco": "Marocco",
			"Netherlands": "Paesi Bassi",
			"Norway": "Norvegia",
			"Poland": "Polonia",
			"Portugal": "Portogallo",
			"Qatar": "Qatar",
			"Romania": "Romania",
			"Singapore": "Singapore",
			"Spain": "Spagna",
			"Sweden": "Svezia",
			"Switzerland": "Svizzera",
			"Taiwan": "Taiwan",
			"Thailand": "Thailandia",
			"UK & Ireland": "Regno Unito e Irlanda",
			"United Arab Emirates (UAE)": "Emirati Arabi Uniti (EAU)",
			"United States of America (USA)": "Stati Uniti d'America (USA)"
		},
		emptyPartnership: 'Nessuna partnership disponibile.',
		emptyRecognitions: 'Nessun riconoscimento disponibile.',
		getStarted: "Inizia",
		watchAShortVideo: 'Guarda un breve video per imparare le basi.',
		search: "Cerca",
		find: "Trova facilmente competenze, offerte o riconoscimenti utilizzando la ricerca globale.",
		highlightsAndQuickAccess: "In evidenza & Accesso rapido",
		exploreKeyHighlights: "Esplora i punti salienti chiave, le competenze e le offerte disponibili o i tuoi contenuti salvati con un clic.",
		globalAndLocalExpertise: "Competenze globali e locali",
		exploreOurWorldwide: "Esplora la nostra competenza mondiale in tecnologia e ingegneria digitale o la nostra competenza locale in diversi paesi.",
		partnerShipsAndRecognitions: "Partnership & Riconoscimenti",
		discoverOurStrategic: "Scopri le nostre partnership strategiche e i nostri risultati.",
		suggestContent: "Suggerisci contenuti",
		shareIdeas: "Condividi idee per nuove competenze, offerte o riconoscimenti mancanti.",
		viewAll: "Visualizza tutto"
	},
	[LANGUAGE.ja.short]: {
		home: 'ホームページ',
		readyToSell: 'すぐに販売できるオファーを作成する',
		gtmPositioning: 'GTMポジショニング',
		globalExpertiseAndOffers: 'グローバルな専門知識とサービス',
		globalClientPresentation: 'グローバルクライアント向けプレゼンテーション',
		highlights: 'ハイライト',
		learnMore: '詳細はこちら ',
		ourExpertiseAndOffers: '当社の専門知識とサービス',
		savedContent: '保存済みコンテンツ',
		info1: '主要産業とコアテクノロジーにおけるグローバルおよびローカルな専門知識を駆使し、世界中のイノベーションを推進するソリューションをご覧ください。\n' +
			'\t\t\t\t\t厳選されたハイライトで当社の優れた実績をご紹介するほか、戦略的パートナーシップや世界的に認められた受賞歴もご覧いただけます。',
		info2: '共和党の力を発見し、その力を最大限に活用する方法を学びましょう - ',
		info3: '今すぐ動画を見て、その潜在能力を解き放ちましょう！',
		industries: '産業分野',
		products: '製品',
		techPractices: "技術実践",
		partnerships: 'パートナーシップ',
		recognitions: '表彰',
		offers: "サービス",
		sectors: 'セクタープレゼンテーション',
		countries: {
			"Australia": "オーストラリア",
			"Austria": "オーストリア",
			"Belgium": "ベルギー",
			"Bulgaria": "ブルガリア",
			"Canada": "カナダ",
			"China": "中国",
			"Colombia": "コロンビア",
			"Czech Republic": "チェコ共和国",
			"Denmark": "デンマーク",
			"France": "フランス",
			"Germany": "ドイツ",
			"Hungary": "ハンガリー",
			"India": "インド",
			"Italy": "イタリア",
			"Japan": "日本",
			"Mexico": "メキシコ",
			"Morocco": "モロッコ",
			"Netherlands": "オランダ",
			"Norway": "ノルウェー",
			"Poland": "ポーランド",
			"Portugal": "ポルトガル",
			"Qatar": "カタール",
			"Romania": "ルーマニア",
			"Singapore": "シンガポール",
			"Spain": "スペイン",
			"Sweden": "スウェーデン",
			"Switzerland": "スイス",
			"Taiwan": "台湾",
			"Thailand": "タイ",
			"UK & Ireland": "イギリス＆アイルランド",
			"United Arab Emirates (UAE)": "アラブ首長国連邦 (UAE)",
			"United States of America (USA)": "アメリカ合衆国 (USA)"
		},
		emptyPartnership: '提携先はありません。',
		emptyRecognitions: '表彰制度はありません。',
		getStarted: "始める",
		watchAShortVideo: '基本を学ぶための短いビデオを見てください。',
		search: "検索",
		find: "グローバル検索を使用して、専門知識、サービス、または表彰を簡単に見つけることができます。",
		highlightsAndQuickAccess: "ハイライト＆クイックアクセス",
		exploreKeyHighlights: "主要なハイライト、利用可能な専門知識とサービス、または保存したコンテンツをワンクリックで確認できます。",
		globalAndLocalExpertise: "グローバル＆ローカルな専門知識",
		exploreOurWorldwide: "世界中のテクノロジーとデジタルエンジニアリングの専門知識や、さまざまな国でのローカルな専門知識を確認できます。",
		partnerShipsAndRecognitions: "パートナーシップ＆表彰",
		discoverOurStrategic: "当社の戦略的なパートナーシップと実績を確認できます。",
		suggestContent: "コンテンツを提案",
		shareIdeas: "新しい専門知識、サービス、または表彰のアイデアを共有してください。",
		viewAll: "すべて表示"
	},
	[LANGUAGE.es.short]: {
		home: 'Página principal',
		readyToSell: 'Crea una oferta lista para vender',
		gtmPositioning: 'Posicionamiento GTM',
		globalExpertiseAndOffers: 'Experiencia y ofertas globales',
		globalClientPresentation: 'Presentación para clientes globales',
		highlights: 'DESTACADOS',
		learnMore: 'Más información',
		ourExpertiseAndOffers: 'Nuestra experiencia y ofertas',
		savedContent: 'Contenido guardado',
		info1: 'Descubra nuestra experiencia global y local en sectores clave y tecnologías esenciales, y conozca las soluciones que impulsan la innovación en todo el mundo.\n' +
			'\t\t\t\t\tConsulte nuestra selección de proyectos destacados, donde encontrará información sobre nuestros mejores trabajos, o explore nuestras alianzas estratégicas y los reconocimientos internacionales que hemos recibido.',
		info2: 'Descubre el poder del Partido Republicano y aprende a sacarle el máximo partido - ',
		info3: '¡mira el vídeo ahora y aprovecha todo su potencial!',
		industries: 'Industrias',
		products: 'Productos',
		techPractices: "Prácticas tecnológicas",
		partnerships: 'Colaboraciones',
		recognitions: 'Reconocimientos',
		offers: "Ofertas",
		sectors: 'Presentaciones sectoriales',
		countries: {
			"Australia": "Australia",
			"Austria": "Austria",
			"Belgium": "Bélgica",
			"Bulgaria": "Bulgaria",
			"Canada": "Canadá",
			"China": "China",
			"Colombia": "Colombia",
			"Czech Republic": "República Checa",
			"Denmark": "Dinamarca",
			"France": "Francia",
			"Germany": "Alemania",
			"Hungary": "Hungría",
			"India": "India",
			"Italy": "Italia",
			"Japan": "Japón",
			"Mexico": "México",
			"Morocco": "Marruecos",
			"Netherlands": "Países Bajos",
			"Norway": "Noruega",
			"Poland": "Polonia",
			"Portugal": "Portugal",
			"Qatar": "Qatar",
			"Romania": "Rumania",
			"Singapore": "Singapur",
			"Spain": "España",
			"Sweden": "Suecia",
			"Switzerland": "Suiza",
			"Taiwan": "Taiwán",
			"Thailand": "Tailandia",
			"UK & Ireland": "Reino Unido e Irlanda",
			"United Arab Emirates (UAE)": "Emiratos Árabes Unidos (EAU)",
			"United States of America (USA)": "Estados Unidos de América (USA)"
		},
		emptyPartnership: 'No hay alianzas disponibles.',
		emptyRecognitions: 'No hay reconocimientos disponibles.',
		getStarted: "Empezar",
		watchAShortVideo: 'Mira un video corto para aprender lo básico.',
		search: "Buscar",
		find: "Encuentra fácilmente experiencia, ofertas o reconocimientos utilizando la búsqueda global.",
		highlightsAndQuickAccess: "Destacados y acceso rápido",
		exploreKeyHighlights: "Explore los aspectos más destacados clave, la experiencia y las ofertas disponibles o su contenido guardado con un clic.",
		globalAndLocalExpertise: "Experiencia global y local",
		exploreOurWorldwide: "Explore nuestra experiencia mundial en tecnología e ingeniería digital o nuestra experiencia local en diferentes países.",
		partnerShipsAndRecognitions: "Colaboraciones y reconocimientos",
		discoverOurStrategic: "Descubra nuestras colaboraciones estratégicas y logros.",
		suggestContent: "Sugerir contenido",
		shareIdeas: "Comparta ideas para nuevas experiencias, ofertas o reconocimientos que falten.",
		viewAll: "Ver todo"
	}
}

